import React from 'react';
import { format } from 'date-fns/esm';
import { ru } from 'date-fns/esm/locale';

export function formatDate(date, formatStr='d MMMM yyyy') {
  if (Date.parse(date)) {
    return format(new Date(date), formatStr, {locale: ru});
  } else {
    return '--';
  }
}

export function toPath(str) {
  let result = str.trim().toLowerCase().split('');
  const translitMap = { і: 'i', ґ: 'g', ё: 'yo', '№': '#', є: 'e', ї: 'yi', а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ж: 'zh', з: 'z', и: 'i', й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'sch', ъ: '\'', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya' };
  result = result.map((letter) => (typeof translitMap[letter] !== 'undefined') ? translitMap[letter] : letter ).join('');
  return result.replace(/[^a-z0-9_-]/g, '-');
}

export function isA(value, type) {
  return value.constructor.name.toLowerCase() === type.toLowerCase();
}


export function objToParams(obj) {
  const result = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] && obj[key] !== '') {
      let value = obj[key];
      if (isA(value, 'date')) {
        value = format(new Date(value), 'yyyy-MM-dd', {locale: ru});
      }
      result[key] = value;
    }
  });
  return result;
}

export function objToQueryString(obj) {
  const clearObj = objToParams(obj);
  return Object.keys(clearObj).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(clearObj[key])}`).join('&');
}

export function parseString(input, format) {
  const converters = {
    string: (input => input.toString()),
    integer: (input => parseInt(input)),
    decimal: (input => parseFloat(input)),
    boolean: (input => (['true', 'yes', '1'].indexOf(input) > -1)),
    date: (input => new Date(Date.parse(input)))
  }
  return converters[format] && converters[format](input);
}

export function searchStringToParams(searchString, propTypes) {
  const searchParams = new URLSearchParams(searchString);
  const searchObject = {};
  let valueType;
  for(var pair of searchParams.entries()) {
     valueType = propTypes[pair[0]];
     if (valueType) {
       searchObject[pair[0]] = parseString(pair[1], valueType);
     }
  }
  return searchObject;
}

export function setObjValue(obj, path, value) {
  const [propName, ...restOfPath] = path;

  if (restOfPath.length) {
    if (typeof obj[propName] !== 'object') {
      obj[propName] = isNaN(restOfPath[0]) ? {} : [];
    }
    setObjValue(obj[propName], restOfPath, value);
  } else {
    obj[propName] = value;
  }
}

export function onChangeNameValue(e) {
  const target = e.target;
  let value;
  if (target.type === 'checkbox') {
    value = target.checked;
  } else {
    value = target.value;
  }
  return {propName: target.name, value: value}
}

export function handleErrors(request) {
  let errors;
  if (request.response) {
    errors = (request.response.data && request.response.data.errors) || [request.response.statusText];
  } else if (request.message) {
    errors = [request.message];
  } else {
    errors = ["Unknown network error."];
  }
  alert(errors.join("\n"));
}

export function renderOptgroups(groups=[]) {
  return groups.map((group) => {
    const options = group.options.map(opt => <option value={opt.id} key={opt.id}>{opt.label}</option>);
    return (<optgroup label={group.label} key={group.id}>{options}</optgroup>);
  });
}

export function numbersSorter(a,b) {
  return a < b ? -1 : (a > b ? 1 : 0);
}

export function debounce(debouncedFunc, delay=100) {
  let timer = null;
  return function(args) {
    if (!timer) {
      timer = setTimeout(() => { 
        debouncedFunc(args); 
        timer = null; 
      }, delay);
    }
  }
}

